<script>
import PopupModal from '@/components/modal/PopupModal.vue';
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import QrcodeVue from 'qrcode.vue'
import { auth as $store } from '@/store/AuthModule'
import RepairFileService from '@/services/RepairFileService'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'AddAttachmentQRCodeModal',
  components: { DialogCloseButton, QrcodeVue, PopupModal },
  data() {
    return {
      loading: false,

      currentRepairFile: null,
      attachmentType: null,
      attachmentFile: null,
      oldAttachmentFile: null,

      qrCodeToken: null,
      qrCodeValue: null,
      qrCodeSize: 200,

      validateButton: undefined,

      resolvePromise: undefined,
      rejectPromise: undefined
    }
  },
  methods: {
    async show(opts = {}) {
      this.currentRepairFile = opts.currentRepairFile
      this.attachmentType = opts.attachmentType
      this.attachmentFile = opts.attachmentFile
      this.oldAttachmentFile = opts.attachmentFile

      this.loading = true
      try {
        this.qrCodeToken = await RepairFileService.getAddAttachmentQRCodeToken(
          this.currentRepairFile.technical_id,
          this.attachmentType,
          $store.state.currentCollaborator.technical_id
        )

        this.qrCodeValue =
          window.location.origin +
          '/public/repair-file/add-attachment?token=' +
          this.qrCodeToken.token

        this.$refs.popup.open()

        return new Promise((resolve, reject) => {
          this.resolvePromise = resolve
          this.rejectPromise = reject
        })
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async _confirm() {
      try {
        this.loading = true
        await RepairFileService.confirmAttachmentAddedByQrCode(
          this.currentRepairFile.technical_id,
          this.qrCodeToken.token,
          $store.state.currentCollaborator.technical_id
        )
        displayToast(this.$t('COMMON.MESSAGE.ADD_ATTACHMENT_SUCCESS'), 'success')
        this.resolvePromise({
          confirmed: true
        })
        this.$refs.popup.close()
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async _reject() {
      this.resolvePromise({
        confirmed: false
      })
      this.$refs.popup.close()
    }
  }
}
</script>

<template>
  <popup-modal ref="popup">
    <v-form ref="form" @submit.prevent="_confirm">
      <DialogCloseButton :close-method="_reject" />

      <div class="content-title">
        {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.TITLE') }}
      </div>

      <div class="mt-8 mb-4 content detail-content">
        <p class="sub-title">
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.MESSAGE_1') }}
        </p>
        <p>
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.MESSAGE_2') }}
        </p>
      </div>

      <div v-if="oldAttachmentFile !== null" class="mt-2 mb-4 content detail-content">
        <p class="sub-title">
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.MESSAGE_WARNING') }}
        </p>
      </div>

      <div class="mt-3 mb-4 qr-code-content">
        <qrcode-vue :value="qrCodeValue" :size="qrCodeSize" level="L" />
      </div>

      <!--Send button-->
      <div class="d-flex justify-center">
        <v-btn
          :disabled="loading"
          :loading="loading"
          class="boom-button dialog-button"
          variant="outlined"
          type="submit"
        >
          {{ $t('ATTACHMENT_MODAL.QR_CODE_MODAL.VALIDATION_BUTTON') }}
          <template v-slot:prepend>
            <img alt="send-icon" class="send-white-svg" src="@/assets/icons/file/send.svg" />
          </template>
        </v-btn>
      </div>
    </v-form>
  </popup-modal>
</template>

<style scoped>
.dialog-button {
  min-width: 200px;
}

.content-title {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.detail-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.qr-code-content {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.send-white-svg {
  height: 100%;
  width: 100%;
  filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
}
</style>
